module.exports = __webpack_public_path__ + "static/media/cert_5125.c3db0e88.jpg";